export default __webpack_public_path__ + "static/media/carro-de-la-compra-3.34553c80.svg";